import * as types from './Type'

const initialState = {
    fetchTable: {},

    loading: true
}
export const ExamReducers = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {

        case types.TABLE_FETCH_AGAIN: return {
            ...state,
            fetchTable: payload,
            loading: false
        }

        case types.EMPTY_STORE_DATA:
            return {
                ...state,
                fetchTable: initialState.fetchTable
            }
        default: return state
    }
}
export default ExamReducers